import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class BrandStore extends StoreModel {
    constructor() {
        super('brand', {
            namePlural: 'brands',
            sort: 'sort',
            api: {
                search: {
                    url: '/api/brands/',
                    params: {},
                },
                load: {
                    url: '/api/brands/',
                    params: {},
                },
                save: {
                    url: '/api/brands/',
                    params: {},
                },
            },
            extendedView: 1,
            queryFilter: {
                brand: 'simms',
            },
        });
    }

    @observable brand = {};

    @observable brands = [];

    getBrandName(key) {
        const brand = this.brands.find((e) => {
            if (e.brandno === key) {
                return true;
            }
            const brandnoEscaped = e.brandno.replace(/[^a-zA-Z]/g, '_');
            if (brandnoEscaped === key) {
                return true;
            }
            return false;
        });
        if (brand) {
            return brand.name;
        }
        return '';
    }
}

const store = new BrandStore();
export default store;



// WEBPACK FOOTER //
// ./stores/brand.js